/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ui_Thresholds_Min_KgInputs */

const en_ui_thresholds_min_kg = /** @type {(inputs: Ui_Thresholds_Min_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Min ${i?.value} kg`)
};

const de_ui_thresholds_min_kg = /** @type {(inputs: Ui_Thresholds_Min_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Min. ${i?.value} kg`)
};

/**
* | output |
* | --- |
* | "Min {value} kg" |
*
* @param {Ui_Thresholds_Min_KgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_min_kg = /** @type {((inputs: Ui_Thresholds_Min_KgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Min_KgInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_min_kg(inputs)
	return de_ui_thresholds_min_kg(inputs)
});